// extracted by mini-css-extract-plugin
export var wordContainer = "_py-0";